import { jsx } from 'react/jsx-runtime';
import { DefaultArea } from '../DefaultArea/DefaultArea.js';
import { SparkArea } from '../SparkArea/SparkArea.js';

function Area({
  areaPath,
  series,
  type
}) {
  if (series.isComparison === true) {
    return null;
  }

  switch (type) {
    case 'spark':
      return /*#__PURE__*/jsx(SparkArea, {
        color: series.color,
        areaPath: areaPath
      });

    default:
    case 'default':
      return /*#__PURE__*/jsx(DefaultArea, {
        series: series,
        areaPath: areaPath
      });
  }
}

export { Area };
